import { AgentBillingModel } from 'api-hooks/agent';
import { CustomerBillingModel } from 'api-hooks/customer';
import { PLACEMENT, StatefulTooltip } from 'baseui/tooltip';
import { InformationCircleSVG } from 'common/assets';
import stylesColors from 'common/styles/styles.colors';
import Separator from 'components/common/separator';
import { StyledText } from 'components/elements/table/components/table';
import Text from 'components/elements/text';
import {
  CardContainer,
  Container,
  SeparatorVertical,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  data: (CustomerBillingModel | AgentBillingModel)[];
}

export default function BillingAccountTooltipList(props: Props) {
  const { t } = useTranslation();

  const list = React.useMemo(() => {
    if (!props.data.length) {
      return (
        <Container>
          <Text variant="body1Regular">{t('common:no_data')}</Text>
        </Container>
      );
    }
    return (
      <Container style={{ gap: 16 }}>
        {props.data.map((item) => (
          <CardContainer key={item.id} style={{ padding: 8 }}>
            <Text variant="LabelSmall">{`${item.name} - ${item.phone} - ${item.address}`}</Text>
            <SeparatorVertical $margin={12} />
            <Text variant="LabelSmall">{`${item.bank} - ${item.accountNumber}`}</Text>
          </CardContainer>
        ))}
      </Container>
    );
  }, [props.data, t]);

  return (
    <StatefulTooltip
      overrides={{
        Body: {
          style: {
            zIndex: 99,
            marginTop: '8px',
            marginLeft: '24px',
          },
        },
        Inner: {
          style: {
            backgroundColor: stylesColors.bg1,
          },
        },
      }}
      placement={PLACEMENT.bottom}
      content={
        <div>
          <SeparatorVertical $margin={24}>
            <Text variant="LabelSmall">{t('common:account_info')}</Text>
          </SeparatorVertical>
          {list}
        </div>
      }
    >
      <StyledText>
        {t('common:view_extra', { extra: t('common:account_info') })}
        <Separator
          gap={4}
          direction="horizontal"
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <InformationCircleSVG color={stylesColors.blueDark} size={16} />
        </Separator>
      </StyledText>
    </StatefulTooltip>
  );
}
